import { Locale as DateLocale } from 'date-fns'
import { es, pl, pt, th, zhCN, zhTW, enAU } from 'date-fns/locale'

import { LocaleCode } from 'types/global'

// Aligns with language ID from backend
export const LANGUAGE = {
  en: 'en',
  es: 'es',
  th: 'th',
  zhHans: 'zh-Hans',
  zhHant: 'zh-Hant',
  pl: 'pl',
  pt: 'pt',
  vn: 'vn',
}

export const DATE_LOCALE_MAP: Record<LocaleCode, DateLocale> = {
  [LANGUAGE.en]: enAU,
  [LANGUAGE.es]: es,
  [LANGUAGE.th]: th,
  [LANGUAGE.zhHans]: zhCN,
  [LANGUAGE.zhHant]: zhTW,
  [LANGUAGE.pl]: pl,
  [LANGUAGE.pt]: pt,
}
